import { z } from 'zod';

export const commonMenuPriceValuesSchema = z
  .object({
    cost: z.number().min(0),
    markup: z.object({ markup: z.number().min(0) }),
    rateFactor: z.number().min(0),
    retailCost: z.number().min(0),
    minRetailCost: z.number().min(0).nullable(),
    maxRetailCost: z.number().min(0).nullable(),
  })
  .superRefine(({ retailCost, minRetailCost, maxRetailCost }, ctx) => {
    if (minRetailCost && retailCost < minRetailCost) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_small,
        minimum: minRetailCost,
        type: 'number',
        inclusive: true,
        message: `Must be at least $${minRetailCost}`,
        path: ['retailCost'],
      });
    }
    if (maxRetailCost && retailCost > maxRetailCost) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_big,
        maximum: maxRetailCost,
        type: 'number',
        inclusive: true,
        message: `Must be no more than $${maxRetailCost}`,
        path: ['retailCost'],
      });
    }
  });
